import { render } from "./ManagementApproachmanagement.vue?vue&type=template&id=b7ce86d8&scoped=true"
import script from "./ManagementApproachmanagement.vue?vue&type=script&lang=js"
export * from "./ManagementApproachmanagement.vue?vue&type=script&lang=js"

import "./ManagementApproachmanagement.vue?vue&type=style&index=0&id=b7ce86d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ce86d8"]])

export default __exports__